
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/narrators",
      function () {
        return require("private-next-pages/narrators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/narrators"])
      });
    }
  